var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMusic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9381 8V13.8223C16.5386 13.8183 16.1122 13.9 15.6957 14.0768C14.4247 14.6163 13.7268 15.8367 14.1368 16.8026C14.5468 17.7686 15.9095 18.1142 17.1805 17.5748C18.1815 17.1498 18.827 16.3026 18.8558 15.4899C18.9082 15.507 18.9381 15.5116 18.9381 15.5V4L8.94388 6.95618V16C8.94388 16.0207 8.94474 16.0413 8.94642 16.0616C8.57507 16.051 8.17959 16.1126 7.78823 16.2551C6.49079 16.7273 5.72994 17.9094 6.08884 18.8955C6.44773 19.8816 7.79046 20.2981 9.08791 19.8259C10.2587 19.3998 10.9925 18.3955 10.8609 17.479C10.9102 17.493 10.9381 17.5 10.9381 17.5V10L16.9381 8Z",
    fill: "#EF4444"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMusic);
export default __webpack_public_path__ + "static/media/icon-music.4320c9eb20479764014448fcf7600c63.svg";
export { ForwardRef as ReactComponent };